import Http from '@/api/http.js'

export default {

  index(filter) {
    return Http.get(`/bonuses`, {params: filter})
  },
  show(id) {
    return Http.get(`/bonuses/${id}`)
  },
}
